import React from "react"
import propTypes from "prop-types"
import { TransitionGroup, CSSTransition } from "react-transition-group"
import { validateForm } from "../../../../../../services/validation"
import "./styles.scss"

import InfoCard, {
  InfoCardItem,
  InfoCardLabel,
  InfoCardTitle,
  InfoCardDescription
} from "../../../../components/InfoCard"
import { Group, Input, TextArea } from "../../../../../../components/Form"
import Button from "../../../../../../components/Button"

class CheckboxCards extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      form: {
        yourGoal: {
          label: "What Is Your Goal",
          name: "yourGoal",
          type: "text",
          value: "",
          required: true,
          class: ""
        },
        describeGoal: {
          label: "Describe Your Goal",
          placeholder: "How will achieving this goal help improve your life.",
          name: "describeGoal",
          type: "textarea",
          value: "",
          required: true,
          class: ""
        }
      },
      isSubmitted: false,
      isHidden: true
    }
  }

  addFormChange = (name, field, value) => {
    const { form } = this.state

    this.setState({
      form: {
        ...form,
        [name]: {
          ...form[name],
          message: "",
          [field]: value
        }
      }
    })
  }

  handleOnChange = (e, index) => {
    const { onChange, name, list } = this.props

    const newList = list
    newList[index].checked = e.currentTarget.checked

    onChange(name, "value", newList)
  }

  handleAdd = e => {
    e.preventDefault()

    const { form } = this.state
    const { addGoal } = this.props

    const results = validateForm(form)

    if (Object.keys(results).length === 0 && results.constructor === Object) {
      addGoal({
        id: null,
        title: form.yourGoal.value,
        content: form.describeGoal.value
      })

      this.setState({
        isSubmitted: false,
        isHidden: true,
        form: {
          yourGoal: {
            ...form.yourGoal,
            value: ""
          },
          describeGoal: {
            ...form.describeGoal,
            value: ""
          }
        }
      })
    } else {
      this.setState({
        isSubmitted: true,
        form: {
          ...form,
          ...results
        }
      })
    }
  }

  onToggleForm = e => {
    e.preventDefault()

    const { isHidden } = this.state

    this.setState({ isHidden: !isHidden })
  }

  render() {
    const { form, isSubmitted, isHidden } = this.state
    const { list, className, classNameActive, hideAddGoal } = this.props

    return (
      <div className="checkbox-cards">
        <div className="row">
          <TransitionGroup component={null}>
            {list.map((checkbox, index) => {
              return (
                <CSSTransition
                  key={checkbox.name}
                  timeout={600}
                  classNames="checkbox-cards_item"
                >
                  <div className="col-md-4">
                    <label
                      htmlFor={checkbox.name}
                      className={`checkbox-cards_item ${
                        checkbox.checked ? "checkbox-cards_item--checked" : ""
                      }`}
                    >
                      <input
                        type="checkbox"
                        id={checkbox.name}
                        name={checkbox.name}
                        onChange={e => {
                          this.handleOnChange(e, index)
                        }}
                        checked={checkbox.checked}
                      />
                      <InfoCard
                        className={`${className} ${
                          checkbox.checked ? classNameActive : ""
                        }`}
                      >
                        <InfoCardItem>
                          <InfoCardLabel>Goal</InfoCardLabel>
                          <InfoCardTitle>{checkbox.title}</InfoCardTitle>
                        </InfoCardItem>

                        <InfoCardItem>
                          <InfoCardLabel>Description</InfoCardLabel>
                          <InfoCardDescription>
                            {checkbox.description.length > 124
                              ? `${checkbox.description.slice(0, 124)}…`
                              : checkbox.description}
                          </InfoCardDescription>
                        </InfoCardItem>

                        <span className="checkbox-cards_icon-checked" />
                      </InfoCard>
                    </label>
                  </div>
                </CSSTransition>
              )
            })}
          </TransitionGroup>
        </div>

        {!hideAddGoal && (
          <>
            <a
              href="/#"
              onClick={this.onToggleForm}
              className="checkbox-cards_add"
            >
              Add Another Goal
            </a>

            <CSSTransition
              in={!isHidden}
              timeout={500}
              unmountOnExit
              classNames="checkbox-cards_add-form"
            >
              <div className="checkbox-cards_add-form">
                <Group>
                  <Input
                    onChange={this.addFormChange}
                    isSubmitted={isSubmitted}
                    field={form.yourGoal}
                  />
                </Group>

                <Group>
                  <TextArea
                    onChange={this.addFormChange}
                    isSubmitted={isSubmitted}
                    field={form.describeGoal}
                  />
                </Group>

                <Group className="form_btn-group">
                  <Button
                    button={{ type: "button" }}
                    onClick={this.handleAdd}
                    className="btn--cancel btn--width-md btn--height-sm font-size--sm"
                  >
                    Add Your Goal
                  </Button>
                </Group>

                <a
                  href="/#"
                  onClick={this.onToggleForm}
                  className="checkbox-cards_add-form_cancel"
                >
                  Cancel Add Form
                </a>
              </div>
            </CSSTransition>
          </>
        )}
      </div>
    )
  }
}

CheckboxCards.propTypes = {
  list: propTypes.arrayOf(
    propTypes.shape({
      title: propTypes.string,
      description: propTypes.string,
      value: propTypes.string,
      type: propTypes.string,
      name: propTypes.string,
      checked: propTypes.bool
    })
  ).isRequired,
  name: propTypes.string.isRequired,
  onChange: propTypes.func.isRequired,
  hideAddGoal: propTypes.bool,
  addGoal: propTypes.func.isRequired,
  className: propTypes.string,
  classNameActive: propTypes.string
}

CheckboxCards.defaultProps = {
  className: "",
  classNameActive: "",
  hideAddGoal: false
}

export default CheckboxCards
